export default __webpack_public_path__ + "280854805ac7bdf3f3894940945f151b.png";